<template>
  <section class="content_section">
    <SimpleList @updateData="getAll()" v-if="this.isLoaded" :defaultCount="defaultCount" :cols="cols" :data="users" :emptyState=options.Lang.Keine_Benutzer_vorhanden :buttonText=options.Lang.Neuen_Mandanten_anlegen buttonAction="User" :hideCols="hideCols" :options="options" :actions="actions" :title=options.Lang.Aktive_Mandanten></SimpleList>
    <FormClient @updateData="getAll()" v-if="options.showClientForm && options.user.loggedIn" :currentClient="options.currentClient" :options="options"></FormClient>
    <FormUser @updateData="getAll()" v-if="options.showUserForm && options.user.loggedIn" :currentFormUser="options.currentFormUser" :options="options"></FormUser>
  </section>
</template>
<script>

const toLower = text => {
  if (text !== null) {
    return text.toString().toLowerCase()
  } else {
    return "";
  }
}

import SimpleList from "@/components/lists/SimpleList";
import FormUser from "@/components/dialogs/FormUser";
import FormClient from "@/components/dialogs/FormClient";

export default {
  name: 'users',
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  components: {
    SimpleList,
    FormUser,
  },
  data() {
    return {
      defaultCount: null,
      search: null,
      searchedUsers: [],
      users: [],
      hideCols: this.options?.user?.supersuper == 1 ? ['id', 'role', 'username', 'pic', 'telefon', 'seeAlert', 'brandings'] : ['id', 'role', 'username', 'pic', 'telefon', 'seeAlert', 'brandings', 'supersuper'],
      cols: ['id', 'firstname', 'lastname', 'username', 'role', 'company', 'telefon', 'status', 'pic', 'seeAlert','brandings', 'supersuper', 'trips_isolated', 'totp_enabled'],
      isLoaded: false,
      actions: [
        {
          icon: 'edit_note',
          action: 'editUser',
          title: this.options.Lang.Benutzer_bearbeiten
        }
      ],
    };
  },
  beforeCreate() {
  },
  beforeMount() {
  },
  mounted(){
    if(this.options.currentRoute != 'Brandings'){
      this.options.showBrandForm = false;
    }
    let self = this;

    self.defaultCount = self.options.defaultCount;

  },
  created() {
    this.getAll();
  },
  methods: {
    getAll() {
      let self = this;
      this.doPost({userdata: self.options.user}, 'getAllUsers', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.responseToTableData(res.data.data, self.cols).then(values => {
            self.users = values;
          })
        }
        self.isLoaded = true;
      });
    },
  }
};
</script>